module.exports = __webpack_public_path__ + "img/logo.a0ddc34a.png";